import { Suspense, useState } from "react";
import CardDelivered from "./vehicle-delivered/CardDelivered";
import CardReturned from "./vehicle-devolution/CardReturned";
import { IVehicleVisualRecord } from "../../../../types/vehicle-visual-record.type";
import DeliveredDetails from "./vehicle-delivered/CardDeliveredDetails/DeliveredDetails";
import ReturnedDetails from "./vehicle-devolution/CardDevolutionDetails/ReturnedDetails";
import { NavLink } from "react-router-dom";

type VehicleCardProps = {
  vehicleRecord: IVehicleVisualRecord;
  isFirstRecord: boolean;
}

export default function VehicleCard(props: VehicleCardProps) {

  const renterUrl = `/clientes/${props.vehicleRecord.renterId}`;
  const [showDeliveredDetails, setShowDeliveredDetails] = useState(false);
  const [showReturnedDetails, setShowReturnedDetails] = useState(false);

  const handleToggleDelivered = () => {
    setShowDeliveredDetails(!showDeliveredDetails);
  }

  const handleToggleReturned = () => {
    setShowReturnedDetails(!showReturnedDetails)
  }

  const handleCloseDelivered = () => {
    setShowDeliveredDetails(false)
  }

  const handleCloseReturned = () => {
    setShowReturnedDetails(false)
  }

  return (
    <section>
      <div className="flex flex-col bg-gray/20 rounded p-2 mx-3 justify-evelyn items-center">
        <h2 className="text-2xl font-semibold mb-4 ">
          {props.isFirstRecord ? (
            <NavLink to={renterUrl} className="text-blue-600 hover:text-bluePrimary" >
              {props.vehicleRecord.nameRenter}
            </NavLink>
          ) : (
            props.vehicleRecord.nameRenter
          )}
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <div>
            {props.vehicleRecord ? (
              <CardDelivered data={props.vehicleRecord} onClick={handleToggleDelivered} />
            ) : <Suspense />}
            {showDeliveredDetails && <DeliveredDetails data={props.vehicleRecord!} onClose={handleCloseDelivered} />}
          </div>
          <div>
            {props.vehicleRecord ? (
              <CardReturned data={props.vehicleRecord} onClick={handleToggleReturned} />
            ) : <Suspense />}
            {showReturnedDetails && <ReturnedDetails data={props.vehicleRecord!} onClose={handleCloseReturned} />}
          </div>
        </div>
      </div>
    </section>
  )
}

